import { useEffect, useRef } from 'react';
import styled from 'styled-components';
import { trackClick } from '../../services/adService';

const DisplayWrapper = styled.div`
  position: relative;
  width: 100%;
  margin: 0 auto;
  border-radius: ${props => props.theme.borderRadius.lg};
  overflow: hidden;
  min-height: 100px;
`;

const DisplayContent = styled.div`
  width: 100%;
  
  iframe {
    border: none;
    width: 100%;
  }
`;

const SponsoredLabel = styled.div`
  position: absolute;
  top: 0.5rem;
  right: 0.5rem;
  padding: 0.25rem 0.5rem;
  background: rgba(0, 0, 0, 0.6);
  color: white;
  font-size: 0.75rem;
  border-radius: ${props => props.theme.borderRadius.sm};
  z-index: 10;
  pointer-events: none;
`;

const DisplayAd = ({ ad, onClick }) => {
  const containerRef = useRef(null);

  useEffect(() => {
    if (ad.htmlContent && containerRef.current) {
      // Create a sandboxed iframe for HTML content
      const iframe = document.createElement('iframe');
      iframe.sandbox = 'allow-scripts allow-same-origin allow-popups allow-forms';
      iframe.style.width = '100%';
      iframe.style.border = 'none';
      iframe.style.minHeight = '100px';
      
      containerRef.current.innerHTML = '';
      containerRef.current.appendChild(iframe);
      
      // Write HTML content to iframe
      const iframeDoc = iframe.contentDocument || iframe.contentWindow.document;
      iframeDoc.open();
      iframeDoc.write(ad.htmlContent);
      iframeDoc.close();

      // Track clicks within iframe
      iframe.contentWindow.addEventListener('click', () => {
        if (onClick) {
          onClick();
        } else {
          trackClick(ad._id);
        }
      });
    }
  }, [ad.htmlContent, ad._id, onClick]);

  if (!ad.htmlContent) {
    return null;
  }

  return (
    <DisplayWrapper data-ad-id={ad._id}>
      <SponsoredLabel>Ad</SponsoredLabel>
      <DisplayContent ref={containerRef} />
    </DisplayWrapper>
  );
};

export default DisplayAd;



